import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_search",
  "use": "icon_search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon_search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 2a4 4 0 100 8 4 4 0 000-8zM0 6a6 6 0 1110.89 3.477l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6.001 6.001 0 010 6z\" fill=\"#A7B1C0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol